import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import Feild_Mapping from '../../../Images/Feild_Mapping.png';

// eslint-disable-next-line react/prop-types
const DecorativeSVG = ({ style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="206" height="259" viewBox="0 0 206 259" fill="none" style={style}>
    <path fillRule="evenodd" clipRule="evenodd" d="M-37.6708 54.1733C-1.44419 79.9999 5.01681 8.71181 41.3375 27.2038C143.128 79.0285 119.667 -20.7298 176.287 10.7841C264.696 59.9914 128.299 259.584 96.3725 267.636C66.5515 275.156 45.1998 269.386 16.6255 244.89C-11.9489 220.393 -32.2265 203.354 -60.191 195.837C-87.7407 188.431 -124.71 174.166 -140.46 118.844C-146.077 99.1133 -159.202 17.3076 -132.933 2.46422C-112.067 -9.32628 -60.7864 37.6937 -37.6708 54.1733Z" fill="#BFDBFE"/>
  </svg>
);

const Pipeline = () => {
  return (
    <Box
      sx={{
        width: '100%',
        py: { xs: 4, md: 8 },
        px: { xs: 2, md: 4 },
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative SVG - Top Right */}
      <DecorativeSVG 
        style={{
          position: 'absolute',
          top: '-100px',
          right: '-100px',
          width: '350.651px',
          height: '313.817px',
          transform: 'rotate(-180.769deg)',
          flexShrink: 0,
          zIndex: 0,
          opacity: 0.8,
        }}
      />

      {/* Decorative SVG - Bottom Left */}
      <DecorativeSVG 
        style={{
          position: 'absolute',
          bottom: '-100px',
          left: '-100px',
          width: '350.651px',
          height: '313.817px',
          transform: 'rotate(-15.769deg)',
          flexShrink: 0,
          zIndex: 0,
          opacity: 0.8,
        }}
      />

      {/* Header Section */}
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        style={{ textAlign: 'center', marginBottom: '3rem', width: '100%', position: 'relative', zIndex: 1 }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3.0rem' },
            color: '#383838',
            mb: 2,
            letterSpacing: '-0.02em',
          }}
        >
          No-Code Pipeline Builder
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: '#383838',
            maxWidth: '700px',
            mx: 'auto',
            fontSize: { xs: '1rem', md: '1.0rem' },
            lineHeight: 1.6,
            fontWeight: 400,
          }}
        >
          Drag, drop, and deploy — it&apos;s that easy. Create custom ETL
          pipelines without writing a single line of code. Just plug in your
          tools and start syncing.
        </Typography>
      </motion.div>

      {/* Pipeline Interface */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
        style={{ width: '100%', maxWidth: '800px', position: 'relative', zIndex: 1 }}
      >
        <Box
          sx={{
            width: '100%',
            height: { xs: '300px', md: '500px' },
            borderRadius: '16px',
            background: `url(${Feild_Mapping}) lightgray 0px -3.167px / 100% 121.488% no-repeat`,
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 15px 0 rgba(0, 0, 0, 0.07)',
            p: { xs: 1, md: 2 },
          }}
        />
      </motion.div>
    </Box>
  );
};

export default Pipeline;
